export const genericModelNumbers: Record<string, { modelCode: string; genericModelNumber: string }> = {
  hotpoint_FR: {
    modelCode: 'FRIDGE HOTPOINT FS',
    genericModelNumber: '98142',
  },
  cannon_TD: {
    modelCode: 'DRYER CANNON FS',
    genericModelNumber: '98143',
  },
  indesit_MW: {
    modelCode: 'MICROWAVE OVEN INDESIT FS',
    genericModelNumber: '98144',
  },
  hotpoint_FF: {
    modelCode: 'COMBI FRIDGE HOTPOINT FS',
    genericModelNumber: '98145',
  },
  ariston_SD: {
    modelCode: 'ARISTON SPIN DRYER',
    genericModelNumber: '98146',
  },
  hotpoint_RQ: {
    modelCode: 'HOTPOINT COOKER ELECTRIC',
    genericModelNumber: '98147',
  },
  hotpoint_CK: {
    modelCode: 'HOTPOINT COOKER GAS',
    genericModelNumber: '98148',
  },
  hotpoint_CH: {
    modelCode: 'HOTPOINT COOKER HOOD',
    genericModelNumber: '98149',
  },
  cannon_RQ: {
    modelCode: 'CANNON ELECTRIC COOKING',
    genericModelNumber: '98150',
  },
  creda_DC: {
    modelCode: 'CREDA COOKER DUAL FUEL',
    genericModelNumber: '98151',
  },
  creda_FR: {
    modelCode: 'CREDA FRIDGE',
    genericModelNumber: '98152',
  },
  creda_FZ: {
    modelCode: 'CREDA FREEZER',
    genericModelNumber: '98153',
  },
  creda_SD: {
    modelCode: 'CREDA SPIN DRYER',
    genericModelNumber: '98154',
  },
  hotpoint_MW: {
    modelCode: 'HOTPOINT MICROWAVE',
    genericModelNumber: '98155',
  },
  hotpoint_SD: {
    modelCode: 'HOTPOINT SPIN DRYER',
    genericModelNumber: '98156',
  },
  scholtes_RQ: {
    modelCode: 'SCHOLTES COOKER ELECTRIC',
    genericModelNumber: '98157',
  },
  scholtes_FR: {
    modelCode: 'SCHOLTES FRIDGE',
    genericModelNumber: '98158',
  },
  ariston_RQ: {
    modelCode: 'ARISTON ELECTRIC COOKER',
    genericModelNumber: '98160',
  },
  ariston_CH: {
    modelCode: 'ARISTON COOKER HOOD',
    genericModelNumber: '98161',
  },
  cannon_CK: {
    modelCode: 'CANNON COOKER GAS',
    genericModelNumber: '98162',
  },
  hotpoint_FS: {
    modelCode: 'HOTPOINT FROST FREE FRIDGE/FREEEZER',
    genericModelNumber: '98163',
  },
  indesit_CH: {
    modelCode: 'INDESIT COOKER HOOD',
    genericModelNumber: '98164',
  },
  indesit_SD: {
    modelCode: 'INDESIT SPIN DRYER',
    genericModelNumber: '98165',
  },
  scholtes_MW: {
    modelCode: 'SCHOLTES MICROWAVE',
    genericModelNumber: '98166',
  },
  hotpoint_DC: {
    modelCode: 'HOTPOINT COOKER DUAL FUEL',
    genericModelNumber: '98167',
  },
  cannon_DC: {
    modelCode: 'CANNON COOKER DUAL FUEL',
    genericModelNumber: '98168',
  },
  creda_CK: {
    modelCode: 'CREDA COOKER GAS',
    genericModelNumber: '98169',
  },
  creda_DW: {
    modelCode: 'CREDA DISHWASHER',
    genericModelNumber: '98170',
  },
  creda_FF: {
    modelCode: 'CREDA FRIDGE FREEZER',
    genericModelNumber: '98171',
  },
  creda_MW: {
    modelCode: 'CREDA MICROWAVE',
    genericModelNumber: '98172',
  },
  scholtes_FF: {
    modelCode: 'SCHOLTES FRIDGE FREEZER',
    genericModelNumber: '98173',
  },
  scholtes_WD: {
    modelCode: 'SCHOLTES WASHER DRYER',
    genericModelNumber: '98174',
  },
  scholtes_AW: {
    modelCode: 'SCHOLTES WASHING MACHINE',
    genericModelNumber: '98175',
  },
  indesit_ME: {
    modelCode: 'INDESIT COFFEE MAKER',
    genericModelNumber: '98176',
  },
  hotpoint_ME: {
    modelCode: 'HOTPOINT COFFEE MAKER',
    genericModelNumber: '98177',
  },
  scholtes_ME: {
    modelCode: 'SCHOLTES COFFEE MAKER',
    genericModelNumber: '98178',
  },
  scholtes_CH: {
    modelCode: 'SCHOLTES COOKER HOOD',
    genericModelNumber: '98179',
  },
  ariston_FS: {
    modelCode: 'ARISTON FRIDGE/FREEZER NO FROST',
    genericModelNumber: '98180',
  },
  indesit_FS: {
    modelCode: 'INDESIT FRIDGE/FREEZER NO FROST',
    genericModelNumber: '98181',
  },
  scholtes_FS: {
    modelCode: 'SCHOLTES FRIDGE FREEZER NO FROST',
    genericModelNumber: '98182',
  },
  ariston_FT: {
    modelCode: 'ARISTON FREEZER NO FROST',
    genericModelNumber: '98183',
  },
  creda_FT: {
    modelCode: 'CREDA FREEZER NO FROST',
    genericModelNumber: '98184',
  },
  hotpoint_FT: {
    modelCode: 'HOTPOINT FREEZER FROST FREE',
    genericModelNumber: '98185',
  },
  indesit_FT: {
    modelCode: 'INDESIT FREEZER NO FROST',
    genericModelNumber: '98186',
  },
  scholtes_FT: {
    modelCode: 'SCHOLTES FREEZER NO FROST',
    genericModelNumber: '98187',
  },
  scholtes_FZ: {
    modelCode: 'SCHOLTES FREEZER',
    genericModelNumber: '98188',
  },
  hotpoint_CN: {
    modelCode: 'HOTPOINT FOOD CENTRE',
    genericModelNumber: '98189',
  },
  ariston_CK: {
    modelCode: 'ARISTON GAS COOKER',
    genericModelNumber: '98190',
  },
  cannon_CH: {
    modelCode: 'CANNON COOKER HOOD',
    genericModelNumber: '98191',
  },
  cannon_MW: {
    modelCode: 'CANNON MICROWAVE',
    genericModelNumber: '98192',
  },
  creda_FS: {
    modelCode: 'CREDA FRIDGE FREEZER NO FROST',
    genericModelNumber: '98193',
  },
  creda_RQ: {
    modelCode: 'CREDA ELECTRIC COOKER',
    genericModelNumber: '98194',
  },
  creda_CH: {
    modelCode: 'CREDA COOKER HOOD',
    genericModelNumber: '98195',
  },
  creda_TD: {
    modelCode: 'CREDA TUMBLE DRYER',
    genericModelNumber: '98196',
  },
  creda_WD: {
    modelCode: 'CREDA  DISHWASHER',
    genericModelNumber: '98197',
  },
  creda_AW: {
    modelCode: 'CREDA WASHING MACHINE',
    genericModelNumber: '98198',
  },
  hotpoint_TT: {
    modelCode: 'HOTPOINT TWIN TUB',
    genericModelNumber: '98199',
  },
  indesit_DC: {
    modelCode: 'INDESIT COOKER DUAL FUEL',
    genericModelNumber: '98200',
  },
  indesit_RQ: {
    modelCode: 'INDESIT COOKER ELECTRIC',
    genericModelNumber: '98201',
  },
  indesit_CK: {
    modelCode: 'INDESIT COOKER GAS',
    genericModelNumber: '98202',
  },
  scholtes_CK: {
    modelCode: 'SCHOLTES COOKER ELECTRIC',
    genericModelNumber: '98203',
  },
  scholtes_DW: {
    modelCode: 'SCHOLTES DISHWASHER',
    genericModelNumber: '98204',
  },
  ariston_MW: {
    modelCode: 'MICROWAVE OVEN ARISTON FS',
    genericModelNumber: '98205',
  },
  indesit_FF: {
    modelCode: 'COMBI FRIDGE INDESIT FS',
    genericModelNumber: '98206',
  },
  ariston_FZ: {
    modelCode: 'FREEZER ARISTON FS',
    genericModelNumber: '98207',
  },
  indesit_FZ: {
    modelCode: 'FREEZER INDESIT FS',
    genericModelNumber: '98208',
  },
  hotpoint_FZ: {
    modelCode: 'FREEZER HOTPOINT FS',
    genericModelNumber: '98209',
  },
  ariston_AW: {
    modelCode: 'WASHER ARISTON FS',
    genericModelNumber: '98211',
  },
  indesit_AW: {
    modelCode: 'WASHER INDESIT FS',
    genericModelNumber: '98212',
  },
  hotpoint_AW: {
    modelCode: 'IWC 81483',
    genericModelNumber: '149375',
  },
  ariston_FF: {
    modelCode: 'COMBI FRIDGE ARISTON FS',
    genericModelNumber: '98214',
  },
  ariston_WD: {
    modelCode: 'WASHER-DRYER ARISTON FS',
    genericModelNumber: '98215',
  },
  indesit_WD: {
    modelCode: 'WASHER-DRYER INDESIT FS',
    genericModelNumber: '98216',
  },
  hotpoint_WD: {
    modelCode: 'WASHER-DRYER HOTPOINT FS',
    genericModelNumber: '98217',
  },
  ariston_TD: {
    modelCode: 'DRYER ARISTON FS',
    genericModelNumber: '98218',
  },
  indesit_TD: {
    modelCode: 'DRYER INDESIT FS',
    genericModelNumber: '98219',
  },
  hotpoint_TD: {
    modelCode: 'DRYER HOTPOINT FS',
    genericModelNumber: '98220',
  },
  ariston_DW: {
    modelCode: 'DISHWASHER ARISTON FS',
    genericModelNumber: '98221',
  },
  indesit_DW: {
    modelCode: 'DISHWASHER INDESIT BI',
    genericModelNumber: '148604',
  },
  hotpoint_DW: {
    modelCode: 'DISHWASHER HOTPOINT BI',
    genericModelNumber: '148605',
  },
  indesit_FR: {
    modelCode: 'FRIDGE INDESIT FS',
    genericModelNumber: '98224',
  },
  ariston_OV: {
    modelCode: 'OVEN HOTPOINT/ARISTON BI',
    genericModelNumber: '98227',
  },
  indesit_OV: {
    modelCode: 'OVEN INDESIT BI',
    genericModelNumber: '98228',
  },
  scholtes_OV: {
    modelCode: 'OVEN SCHOLTES BI',
    genericModelNumber: '98229',
  },
  hotpoint_OV: {
    modelCode: 'OVEN HOTPOINT BI',
    genericModelNumber: '98230',
  },
  ariston_FR: {
    modelCode: 'FRIDGE ARISTON FS',
    genericModelNumber: '98231',
  },
  cannon_DW: {
    modelCode: 'DISHWASHER CANNONBI',
    genericModelNumber: '98232',
  },
  ignis_FS: {
    modelCode: 'IGNIS FROST FREE FRIDGE/FREEEZER',
    genericModelNumber: '98263',
  },
  beko_WD: {
    modelCode: 'MB-BEK-WASHER DRYER',
    genericModelNumber: '98272',
  },
  leisure_DO: {
    modelCode: 'MB-LEI-DOUBLE OVEN',
    genericModelNumber: '98282',
  },
  beko_EA: {
    modelCode: 'MB-BEK-CONDENSING TUMBLE DRYER',
    genericModelNumber: '98308',
  },
  beko_TD: {
    modelCode: 'MB-BEK-TUMBLE DRYER',
    genericModelNumber: '98317',
  },
  beko_EH: {
    modelCode: 'MB-BEK-ELECTRIC HOB',
    genericModelNumber: '98338',
  },
  beko_EO: {
    modelCode: 'MB-BEK-ELECTRIC OVEN',
    genericModelNumber: '98360',
  },
  beko_DO: {
    modelCode: 'MB-BEK-DOUBLE OVEN',
    genericModelNumber: '98387',
  },
  beko_DW: {
    modelCode: 'MB-BEK-DISHWASHER',
    genericModelNumber: '98388',
  },
  beko_FZ: {
    modelCode: 'MB-BEK-FREEZER',
    genericModelNumber: '98389',
  },
  beko_AW: {
    modelCode: 'MB-BEK-WASHING MACHINE',
    genericModelNumber: '98399',
  },
  grundig_AW: {
    modelCode: 'MB-GRD-WASHING MACHINE',
    genericModelNumber: '98405',
  },
  beko_CK: {
    modelCode: 'MB-BEK-GAS COOKER',
    genericModelNumber: '98449',
  },
  leisure_CK: {
    modelCode: 'MB-LEI-GAS COOKER',
    genericModelNumber: '98458',
  },
  leisure_RQ: {
    modelCode: 'MB-LEI-RANGE COOKER',
    genericModelNumber: '98482',
  },
  beko_FF: {
    modelCode: 'MB-BEK-FRIDGE FREEZER',
    genericModelNumber: '98486',
  },
  blomberg_FR: {
    modelCode: 'MB-BLM-FRIDGE',
    genericModelNumber: '98487',
  },
  leisure_EO: {
    modelCode: 'MB-LEI-ELECTRIC OVEN',
    genericModelNumber: '98500',
  },
  beko_FT: {
    modelCode: 'MB-BEK-FROST FREE FREEZER',
    genericModelNumber: '98502',
  },
  beko_MW: {
    modelCode: 'MB-BEK-MICROWAVE',
    genericModelNumber: '98508',
  },
  beko_FR: {
    modelCode: 'MB-BEK-FRIDGE',
    genericModelNumber: '98511',
  },
  blomberg_AW: {
    modelCode: 'MB-BLM-WASHING MACHINE',
    genericModelNumber: '98532',
  },
  blomberg_FZ: {
    modelCode: 'MB-BLM-FREEZER',
    genericModelNumber: '98553',
  },
  beko_CN: {
    modelCode: 'MB-BEK-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '98558',
  },
  beko_CH: {
    modelCode: 'MB-BEK-COOKER HOOD',
    genericModelNumber: '98559',
  },
  beko_EC: {
    modelCode: 'MB-BEK-ELECTRIC COOKER',
    genericModelNumber: '98560',
  },
  blomberg_DO: {
    modelCode: 'MB-BLM-DOUBLE OVEN',
    genericModelNumber: '98570',
  },
  blomberg_EA: {
    modelCode: 'MB-BLM-CONDENSING TUMBLE DRYER',
    genericModelNumber: '98576',
  },
  blomberg_FS: {
    modelCode: 'MB-BLM-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '98577',
  },
  blomberg_EH: {
    modelCode: 'MB-BLM-ELECTRIC HOB',
    genericModelNumber: '98613',
  },
  blomberg_FF: {
    modelCode: 'MB-BLM-FRIDGE FREEZER',
    genericModelNumber: '98654',
  },
  blomberg_TD: {
    modelCode: 'MB-BLM-TUMBLE DRYER',
    genericModelNumber: '98655',
  },
  blomberg_EO: {
    modelCode: 'MB-BLM-ELECTRIC OVEN',
    genericModelNumber: '98668',
  },
  blomberg_CK: {
    modelCode: 'MB-BLM-GAS COOKER',
    genericModelNumber: '98688',
  },
  beko_RQ: {
    modelCode: 'MB-BEK-RANGE COOKER',
    genericModelNumber: '98700',
  },
  blomberg_DW: {
    modelCode: 'MB-BLM-DISHWASHER',
    genericModelNumber: '98701',
  },
  blomberg_FT: {
    modelCode: 'MB-BLM-FROST FREE FREEZER',
    genericModelNumber: '98702',
  },
  beko_FS: {
    modelCode: 'MB-BEK-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '98709',
  },
  leisure_FZ: {
    modelCode: 'MB-LEI-FREEZER',
    genericModelNumber: '98846',
  },
  leisure_CH: {
    modelCode: 'MB-LEI-COOKER HOOD',
    genericModelNumber: '99072',
  },
  leisure_EH: {
    modelCode: 'MB-LEI-ELECTRIC HOB',
    genericModelNumber: '99073',
  },
  leisure_FS: {
    modelCode: 'MB-LEI-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '99180',
  },
  leisure_DW: {
    modelCode: 'MB-LEI-DISHWASHER',
    genericModelNumber: '99220',
  },
  leisure_FF: {
    modelCode: 'MB-LEI-FRIDGE FREEZER',
    genericModelNumber: '99221',
  },
  leisure_EC: {
    modelCode: 'MB-LEI-ELECTRIC COOKER',
    genericModelNumber: '99222',
  },
  leisure_CN: {
    modelCode: 'MB-LEI-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '99246',
  },
  swan_MW: {
    modelCode: 'MB-SWA-MICROWAVE',
    genericModelNumber: '99357',
  },
  proline_EH: {
    modelCode: 'MB-PRL-ELECTRIC HOB',
    genericModelNumber: '99441',
  },
  proline_EO: {
    modelCode: 'MB-PRL-ELECTRIC OVEN',
    genericModelNumber: '99465',
  },
  swan_FR: {
    modelCode: 'MB-SWA-FRIDGE',
    genericModelNumber: '99504',
  },
  swan_FF: {
    modelCode: 'MB-SWA-FRIDGE FREEZER',
    genericModelNumber: '99523',
  },
  proline_FT: {
    modelCode: 'MB-PRL-FROST FREE FREEZER',
    genericModelNumber: '99646',
  },
  swan_DW: {
    modelCode: 'MB-SWA-DISHWASHER',
    genericModelNumber: '99648',
  },
  proline_EC: {
    modelCode: 'MB-PRL-ELECTRIC COOKER',
    genericModelNumber: '99666',
  },
  swan_CK: {
    modelCode: 'MB-SWA-GAS COOKER',
    genericModelNumber: '99696',
  },
  proline_AW: {
    modelCode: 'MB-PRL-WASHING MACHINE',
    genericModelNumber: '99736',
  },
  swan_FZ: {
    modelCode: 'MB-SWA-FREEZER',
    genericModelNumber: '99740',
  },
  proline_FS: {
    modelCode: 'MB-PRL-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '99750',
  },
  proline_FZ: {
    modelCode: 'MB-PRL-FREEZER',
    genericModelNumber: '99767',
  },
  proline_FR: {
    modelCode: 'MB-PRL-FRIDGE',
    genericModelNumber: '99768',
  },
  swan_FS: {
    modelCode: 'MB-SWA-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '99815',
  },
  proline_TD: {
    modelCode: 'MB-PRL-TUMBLE DRYER',
    genericModelNumber: '99826',
  },
  swan_EO: {
    modelCode: 'MB-SWA-ELECTRIC OVEN',
    genericModelNumber: '99836',
  },
  swan_AW: {
    modelCode: 'MB-SWA-WASHING MACHINE',
    genericModelNumber: '99894',
  },
  proline_CH: {
    modelCode: 'MB-PRL-COOKER HOOD',
    genericModelNumber: '99901',
  },
  proline_DW: {
    modelCode: 'MB-PRL-DISHWASHER',
    genericModelNumber: '99957',
  },
  proline_MW: {
    modelCode: 'MB-PRL-MICROWAVE',
    genericModelNumber: '99971',
  },
  proline_CK: {
    modelCode: 'MB-PRL-GAS COOKER',
    genericModelNumber: '100021',
  },
  proline_EA: {
    modelCode: 'MB-PRL-CONDENSING TUMBLE DRYER',
    genericModelNumber: '100052',
  },
  proline_FF: {
    modelCode: 'MB-PRL-FRIDGE FREEZER',
    genericModelNumber: '100053',
  },
  whirlpool_RQ: {
    modelCode: 'WHIRLPOOL COOKER ELECTRIC',
    genericModelNumber: '100057',
  },
  whirlpool_AW: {
    modelCode: 'WASHER WHIRLPOOL FS',
    genericModelNumber: '100058',
  },
  whirlpool_TD: {
    modelCode: 'DRYER WHIRLPOOL FS',
    genericModelNumber: '100059',
  },
  whirlpool_FZ: {
    modelCode: 'FREEZER WHIRLPOOL FS',
    genericModelNumber: '100060',
  },
  whirlpool_FR: {
    modelCode: 'FRIDGE WHIRLPOOL  FS',
    genericModelNumber: '100061',
  },
  whirlpool_DW: {
    modelCode: 'DISHWASHER WHIRLPOOL BI',
    genericModelNumber: '148606',
  },
  whirlpool_CH: {
    modelCode: 'WHIRLPOOL COOKER HOOD BI',
    genericModelNumber: '100063',
  },
  whirlpool_FS: {
    modelCode: 'WHIRLPOOL FROST FREE FRIDGE/FREEEZER',
    genericModelNumber: '100064',
  },
  bauknecht_DW: {
    modelCode: 'DISHWASHER BAUKNECHT FS',
    genericModelNumber: '100065',
  },
  bauknecht_FR: {
    modelCode: 'BAUKNECHT FRIDGE FS',
    genericModelNumber: '100066',
  },
  whirlpool_CN: {
    modelCode: 'WHIRLPOOL FOOD CENTRE',
    genericModelNumber: '100067',
  },
  ignis_DW: {
    modelCode: 'DISHWASHER IGNIS FS',
    genericModelNumber: '100068',
  },
  ignis_FZ: {
    modelCode: 'FREEZER IGNIS FS',
    genericModelNumber: '100069',
  },
  bauknecht_DC: {
    modelCode: 'BAUKNECHT COOKER DUAL FUEL',
    genericModelNumber: '100070',
  },
  ignis_TD: {
    modelCode: 'DRYER IGNIS FS',
    genericModelNumber: '100071',
  },
  ignis_RQ: {
    modelCode: 'IGNIS COOKER ELECTRIC',
    genericModelNumber: '100072',
  },
  bauknecht_AW: {
    modelCode: 'WASHER BAUKNECHT FS',
    genericModelNumber: '100073',
  },
  bauknecht_RQ: {
    modelCode: 'BAUKNECHT COOKER ELECTRIC',
    genericModelNumber: '100074',
  },
  bauknecht_FF: {
    modelCode: 'COMBI FRIDGE BAUKNECHT FS',
    genericModelNumber: '100075',
  },
  bauknecht_FT: {
    modelCode: 'BAUKNECHT FREEZER FROST FREE',
    genericModelNumber: '100076',
  },
  bauknecht_ME: {
    modelCode: 'BAUKNECHT COFFEE MAKER',
    genericModelNumber: '100077',
  },
  bauknecht_SD: {
    modelCode: 'BAUKNECHT SPIN DRYER',
    genericModelNumber: '100078',
  },
  bauknecht_CH: {
    modelCode: 'BAUKNECHT COOKER HOOD BI',
    genericModelNumber: '100079',
  },
  bauknecht_TT: {
    modelCode: 'BAUKNECHT TWIN TUB',
    genericModelNumber: '100080',
  },
  whirlpool_SD: {
    modelCode: 'WHIRLPOOL SPIN DRYER',
    genericModelNumber: '100081',
  },
  bauknecht_FZ: {
    modelCode: 'FREEZER BAUKNECHT FS',
    genericModelNumber: '100082',
  },
  whirlpool_FT: {
    modelCode: 'WHIRLPOOL FREEZER FROST FREE',
    genericModelNumber: '100083',
  },
  whirlpool_WD: {
    modelCode: 'WASHER-DRYER WHIRLPOOL FS',
    genericModelNumber: '100084',
  },
  bauknecht_TD: {
    modelCode: 'DRYER BAUKNECHT FS',
    genericModelNumber: '100085',
  },
  bauknecht_MW: {
    modelCode: 'BAUKNECHT MICROWAVE',
    genericModelNumber: '100086',
  },
  bauknecht_WD: {
    modelCode: 'WASHER-DRYER BAUKNECHT FS',
    genericModelNumber: '100087',
  },
  bauknecht_CN: {
    modelCode: 'BAUKNECHT FOOD CENTRE',
    genericModelNumber: '100088',
  },
  whirlpool_CK: {
    modelCode: 'WHIRLPOOL COOKER GAS',
    genericModelNumber: '100089',
  },
  ignis_FR: {
    modelCode: 'IGNIS FRIDGE FS',
    genericModelNumber: '100090',
  },
  bauknecht_HB: {
    modelCode: 'HOB BAUKNECHT BI',
    genericModelNumber: '100091',
  },
  bauknecht_CK: {
    modelCode: 'BAUKNECHT COOKER GAS',
    genericModelNumber: '100092',
  },
  bauknecht_FS: {
    modelCode: 'BAUKNECHT FROST FREE FRIDGE/FREEEZER',
    genericModelNumber: '100093',
  },
  ignis_AW: {
    modelCode: 'WASHER IGNIS FS',
    genericModelNumber: '100094',
  },
  whirlpool_DC: {
    modelCode: 'WHIRLPOOL COOKER DUAL FUEL',
    genericModelNumber: '100095',
  },
  whirlpool_TT: {
    modelCode: 'WHIRLPOOL TWIN TUB',
    genericModelNumber: '100096',
  },
  whirlpool_MW: {
    modelCode: 'WHIRLPOOL MICROWAVE',
    genericModelNumber: '100097',
  },
  whirlpool_HB: {
    modelCode: 'HOB WHIRLPOOL BI',
    genericModelNumber: '100098',
  },
  whirlpool_FF: {
    modelCode: 'COMBI FRIDGE WHIRLPOOL FS',
    genericModelNumber: '100099',
  },
  whirlpool_ME: {
    modelCode: 'WHIRLPOOL COFFEE MAKER',
    genericModelNumber: '100100',
  },
  kitchenaid_AW: {
    modelCode: 'WASHER KITCHENAID FS',
    genericModelNumber: '100101',
  },
  maytag_ME: {
    modelCode: 'MAYTAG COFFEE MAKER',
    genericModelNumber: '100102',
  },
  maytag_MW: {
    modelCode: 'MAYTAG MICROWAVE',
    genericModelNumber: '100103',
  },
  maytag_DC: {
    modelCode: 'MAYTAG COOKER DUAL FUEL',
    genericModelNumber: '100104',
  },
  kitchenaid_CK: {
    modelCode: 'KITCHENAID COOKER GAS',
    genericModelNumber: '100105',
  },
  maytag_SD: {
    modelCode: 'MAYTAG SPIN DRYER',
    genericModelNumber: '100106',
  },
  kitchenaid_SD: {
    modelCode: 'KITCHENAID SPIN DRYER',
    genericModelNumber: '100107',
  },
  maytag_FR: {
    modelCode: 'MAYTAG FRIDGE FS',
    genericModelNumber: '100108',
  },
  maytag_HB: {
    modelCode: 'HOB MAYTAG BI',
    genericModelNumber: '100109',
  },
  maytag_CH: {
    modelCode: 'MAYTAG COOKER HOOD',
    genericModelNumber: '100110',
  },
  ignis_MW: {
    modelCode: 'MICROWAVE IKEA',
    genericModelNumber: '148901',
  },
  kitchenaid_TD: {
    modelCode: 'DRYER KITCHENAID FS',
    genericModelNumber: '100112',
  },
  ignis_CK: {
    modelCode: 'IGNIS COOKER GAS',
    genericModelNumber: '100113',
  },
  maytag_CK: {
    modelCode: 'MAYTAG COOKER GAS',
    genericModelNumber: '100114',
  },
  kitchenaid_CN: {
    modelCode: 'KITCHENAID FOOD CENTRE',
    genericModelNumber: '100115',
  },
  kitchenaid_HB: {
    modelCode: 'HOB KITCHENAID BI',
    genericModelNumber: '100116',
  },
  kitchenaid_FT: {
    modelCode: 'KITCHENAID FREEZER FROST FREE',
    genericModelNumber: '100117',
  },
  kitchenaid_DC: {
    modelCode: 'KITCHENAID COOKER DUAL FUEL',
    genericModelNumber: '100118',
  },
  ignis_CH: {
    modelCode: 'IGNIS COOKER HOOD BI',
    genericModelNumber: '100119',
  },
  maytag_CN: {
    modelCode: 'MAYTAG FOOD CENTRE',
    genericModelNumber: '100120',
  },
  ignis_SD: {
    modelCode: 'IGNIS SPIN DRYER',
    genericModelNumber: '100121',
  },
  ignis_TT: {
    modelCode: 'IGNIS TWIN TUB',
    genericModelNumber: '100122',
  },
  maytag_FZ: {
    modelCode: 'FREEZER MAYTAG FS',
    genericModelNumber: '100123',
  },
  maytag_WD: {
    modelCode: 'WASHER-DRYER MAYTAG FS',
    genericModelNumber: '100124',
  },
  maytag_TD: {
    modelCode: 'DRYER MAYTAG FS',
    genericModelNumber: '100125',
  },
  maytag_FT: {
    modelCode: 'MAYTAG FREEZER FROST FREE',
    genericModelNumber: '100126',
  },
  kitchenaid_WD: {
    modelCode: 'WASHER-DRYER KITCHENAID FS',
    genericModelNumber: '100127',
  },
  ignis_FT: {
    modelCode: 'IGNIS FREEZER FROST FREE',
    genericModelNumber: '100128',
  },
  kitchenaid_DW: {
    modelCode: 'DISHWASHER KITCHENAID FS',
    genericModelNumber: '100129',
  },
  ignis_ME: {
    modelCode: 'IGNIS COFFEE MAKER',
    genericModelNumber: '100130',
  },
  kitchenaid_RQ: {
    modelCode: 'KITCHENAID COOKER ELECTRIC',
    genericModelNumber: '100131',
  },
  ignis_DC: {
    modelCode: 'IGNIS COOKER DUAL FUEL',
    genericModelNumber: '100132',
  },
  kitchenaid_MW: {
    modelCode: 'KITCHENAID MICROWAVE',
    genericModelNumber: '100133',
  },
  kitchenaid_TT: {
    modelCode: 'KITCHENAID TWIN TUB',
    genericModelNumber: '100134',
  },
  kitchenaid_FF: {
    modelCode: 'COMBI FRIDGE KITCHENAID FS',
    genericModelNumber: '100135',
  },
  kitchenaid_FR: {
    modelCode: 'KITCHENAID FRIDGE FS',
    genericModelNumber: '100136',
  },
  maytag_AW: {
    modelCode: 'WASHER MAYTAG FS',
    genericModelNumber: '100137',
  },
  kitchenaid_CH: {
    modelCode: 'KITCHENAID COOKER HOOD BI',
    genericModelNumber: '100138',
  },
  maytag_TT: {
    modelCode: 'MAYTAG TWIN TUB',
    genericModelNumber: '100139',
  },
  maytag_FS: {
    modelCode: 'MAYTAG FROST FREE FRIDGE/FREEEZER',
    genericModelNumber: '100140',
  },
  kitchenaid_FZ: {
    modelCode: 'FREEZER KITCHENAID FS',
    genericModelNumber: '100141',
  },
  ignis_HB: {
    modelCode: 'HOB IGNIS BI',
    genericModelNumber: '100142',
  },
  kitchenaid_FS: {
    modelCode: 'KITCHENAID FROST FREE FRIDGE/FREEEZER',
    genericModelNumber: '100143',
  },
  maytag_FF: {
    modelCode: 'COMBI FRIDGE MAYTAG FS',
    genericModelNumber: '100144',
  },
  ignis_FF: {
    modelCode: 'COMBI FRIDGE IGNIS FS',
    genericModelNumber: '100145',
  },
  ignis_WD: {
    modelCode: 'WASHER-DRYER IGNIS FS',
    genericModelNumber: '100146',
  },
  maytag_DW: {
    modelCode: 'DISHWASHER MAYTAG FS',
    genericModelNumber: '100147',
  },
  ignis_CN: {
    modelCode: 'IGNIS FOOD CENTRE',
    genericModelNumber: '100148',
  },
  maytag_RQ: {
    modelCode: 'MAYTAG COOKER ELECTRIC',
    genericModelNumber: '100149',
  },
  kitchenaid_ME: {
    modelCode: 'KITCHENAID SDA COFFEE MAKER',
    genericModelNumber: '102948',
  },
  whirlpool_OV: {
    modelCode: 'WHIRLPOOL OVEN (BI)',
    genericModelNumber: '100151',
  },
  ignis_OV: {
    modelCode: 'IGNIS OVEN BI',
    genericModelNumber: '100152',
  },
  bauknecht_OV: {
    modelCode: 'BAUKNECHT OVEN BI',
    genericModelNumber: '100153',
  },
  swan_TD: {
    modelCode: 'MB-SWA-TUMBLE DRYER',
    genericModelNumber: '101210',
  },
  swan_CH: {
    modelCode: 'MB-SWA-COOKER HOOD',
    genericModelNumber: '101199',
  },
  swan_CN: {
    modelCode: 'MB-SWA-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '101200',
  },
  swan_EC: {
    modelCode: 'MB-SWA-ELECTRIC COOKER',
    genericModelNumber: '101201',
  },
  swan_DC: {
    modelCode: 'MB-SWA-DUAL FUEL COOKER',
    genericModelNumber: '101202',
  },
  swan_DO: {
    modelCode: 'MB-SWA-DOUBLE OVEN',
    genericModelNumber: '101203',
  },
  swan_EA: {
    modelCode: 'MB-SWA-CONDENSING TUMBLE DRYER',
    genericModelNumber: '101204',
  },
  swan_FT: {
    modelCode: 'MB-SWA-FROST FREE FREEZER',
    genericModelNumber: '101205',
  },
  swan_EH: {
    modelCode: 'MB-SWA-ELECTRIC HOB',
    genericModelNumber: '101206',
  },
  swan_ME: {
    modelCode: 'MB-SWA-COFFEE MAKER',
    genericModelNumber: '101207',
  },
  swan_RQ: {
    modelCode: 'MB-SWA-RANGE COOKER',
    genericModelNumber: '101208',
  },
  swan_SD: {
    modelCode: 'MB-SWA-SPIN DRYER',
    genericModelNumber: '101209',
  },
  swan_TT: {
    modelCode: 'MB-SWA-TWIN TUB',
    genericModelNumber: '101211',
  },
  swan_WD: {
    modelCode: 'MB-SWA-WASHER DRYER',
    genericModelNumber: '101212',
  },
  proline_CN: {
    modelCode: 'MB-PRL-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '101517',
  },
  proline_DC: {
    modelCode: 'MB-PRL-DUAL FUEL COOKER',
    genericModelNumber: '101518',
  },
  proline_DO: {
    modelCode: 'MB-PRL-DOUBLE OVEN',
    genericModelNumber: '101519',
  },
  proline_ME: {
    modelCode: 'MB-PRL-COFFEE MAKER',
    genericModelNumber: '101520',
  },
  proline_RQ: {
    modelCode: 'MB-PRL-RANGE COOKER',
    genericModelNumber: '101521',
  },
  proline_SD: {
    modelCode: 'MB-PRL-SPIN DRYER',
    genericModelNumber: '101522',
  },
  proline_TT: {
    modelCode: 'MB-PRL-TWIN TUB',
    genericModelNumber: '101523',
  },
  proline_WD: {
    modelCode: 'MB-PRL-WASHER DRYER',
    genericModelNumber: '101524',
  },
  'ikea (multibranding)_AW': {
    modelCode: 'MB-ZIK-WASHING MACHINE',
    genericModelNumber: '101567',
  },
  'ikea (multibranding)_CH': {
    modelCode: 'MB-ZIK-COOKER HOOD',
    genericModelNumber: '101568',
  },
  'ikea (multibranding)_CK': {
    modelCode: 'MB-ZIK-GAS COOKER',
    genericModelNumber: '101569',
  },
  'ikea (multibranding)_CN': {
    modelCode: 'MB-ZIK-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '101570',
  },
  'ikea (multibranding)_EC': {
    modelCode: 'MB-ZIK-ELECTRIC COOKER',
    genericModelNumber: '101571',
  },
  'ikea (multibranding)_DC': {
    modelCode: 'MB-ZIK-DUAL FUEL COOKER',
    genericModelNumber: '101572',
  },
  'ikea (multibranding)_DO': {
    modelCode: 'MB-ZIK-DOUBLE OVEN',
    genericModelNumber: '101573',
  },
  'ikea (multibranding)_DW': {
    modelCode: 'MB-ZIK-DISHWASHER',
    genericModelNumber: '101574',
  },
  'ikea (multibranding)_EA': {
    modelCode: 'MB-ZIK-CONDENSING TUMBLE DRYER',
    genericModelNumber: '101575',
  },
  'ikea (multibranding)_FF': {
    modelCode: 'MB-ZIK-FRIDGE FREEZER',
    genericModelNumber: '101576',
  },
  'ikea (multibranding)_FR': {
    modelCode: 'MB-ZIK-FRIDGE',
    genericModelNumber: '101577',
  },
  'ikea (multibranding)_FS': {
    modelCode: 'MB-ZIK-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '101578',
  },
  'ikea (multibranding)_FT': {
    modelCode: 'MB-ZIK-FROST FREE FREEZER',
    genericModelNumber: '101579',
  },
  'ikea (multibranding)_FZ': {
    modelCode: 'MB-ZIK-FREEZER',
    genericModelNumber: '101580',
  },
  'ikea (multibranding)_EH': {
    modelCode: 'MB-ZIK-ELECTRIC HOB',
    genericModelNumber: '101581',
  },
  'ikea (multibranding)_ME': {
    modelCode: 'MB-ZIK-COFFEE MAKER',
    genericModelNumber: '101582',
  },
  'ikea (multibranding)_MW': {
    modelCode: 'MB-ZIK-MICROWAVE',
    genericModelNumber: '101583',
  },
  'ikea (multibranding)_EO': {
    modelCode: 'MB-ZIK-ELECTRIC OVEN',
    genericModelNumber: '101584',
  },
  'ikea (multibranding)_RQ': {
    modelCode: 'MB-ZIK-RANGE COOKER',
    genericModelNumber: '101585',
  },
  'ikea (multibranding)_SD': {
    modelCode: 'MB-ZIK-SPIN DRYER',
    genericModelNumber: '101586',
  },
  'ikea (multibranding)_TD': {
    modelCode: 'MB-ZIK-TUMBLE DRYER',
    genericModelNumber: '101587',
  },
  'ikea (multibranding)_TT': {
    modelCode: 'MB-ZIK-TWIN TUB',
    genericModelNumber: '101588',
  },
  'ikea (multibranding)_WD': {
    modelCode: 'MB-ZIK-WASHER DRYER',
    genericModelNumber: '101589',
  },
  proline_OC: {
    modelCode: 'MB-PRL-GAS OVEN',
    genericModelNumber: '102300',
  },
  grundig_OC: {
    modelCode: 'MB-GRD-GAS OVEN',
    genericModelNumber: '102363',
  },
  beko_SD: {
    modelCode: 'MB-BEK-SPIN DRYER',
    genericModelNumber: '102514',
  },
  beko_OC: {
    modelCode: 'MB-BEK-GAS OVEN',
    genericModelNumber: '102515',
  },
  blomberg_CN: {
    modelCode: 'MB-BLM-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '102630',
  },
  blomberg_EC: {
    modelCode: 'MB-BLM-ELECTRIC COOKER',
    genericModelNumber: '102631',
  },
  blomberg_MW: {
    modelCode: 'MB-BLM-MICROWAVE',
    genericModelNumber: '102632',
  },
  blomberg_RQ: {
    modelCode: 'MB-BLM-RANGE COOKER',
    genericModelNumber: '102633',
  },
  blomberg_SD: {
    modelCode: 'MB-BLM-SPIN DRYER',
    genericModelNumber: '102634',
  },
  beko_DC: {
    modelCode: 'MB-BEK-DUAL FUEL COOKER',
    genericModelNumber: '102663',
  },
  beko_ME: {
    modelCode: 'MB-BEK-COFFEE MAKER',
    genericModelNumber: '102664',
  },
  beko_TT: {
    modelCode: 'MB-BEK-TWIN TUB',
    genericModelNumber: '102665',
  },
  blomberg_DC: {
    modelCode: 'MB-BLM-DUAL FUEL COOKER',
    genericModelNumber: '102686',
  },
  blomberg_ME: {
    modelCode: 'MB-BLM-COFFEE MAKER',
    genericModelNumber: '102687',
  },
  blomberg_TT: {
    modelCode: 'MB-BLM-TWIN TUB',
    genericModelNumber: '102688',
  },
  blomberg_CH: {
    modelCode: 'MB-BLM-COOKER HOOD',
    genericModelNumber: '102689',
  },
  blomberg_WD: {
    modelCode: 'MB-BLM-WASHER DRYER',
    genericModelNumber: '102690',
  },
  blomberg_OC: {
    modelCode: 'MB-BLM-GAS OVEN',
    genericModelNumber: '102691',
  },
  grundig_DC: {
    modelCode: 'MB-GRD-DUAL FUEL COOKER',
    genericModelNumber: '103150',
  },
  grundig_ME: {
    modelCode: 'MB-GRD-COFFEE MAKER',
    genericModelNumber: '103151',
  },
  grundig_TT: {
    modelCode: 'MB-GRD-TWIN TUB',
    genericModelNumber: '103152',
  },
  grundig_CH: {
    modelCode: 'MB-GRD-COOKER HOOD',
    genericModelNumber: '103153',
  },
  grundig_CK: {
    modelCode: 'MB-GRD-GAS COOKER',
    genericModelNumber: '103154',
  },
  grundig_CN: {
    modelCode: 'MB-GRD-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '103155',
  },
  grundig_EC: {
    modelCode: 'MB-GRD-ELECTRIC COOKER',
    genericModelNumber: '103156',
  },
  grundig_DO: {
    modelCode: 'MB-GRD-DOUBLE OVEN',
    genericModelNumber: '103157',
  },
  grundig_DW: {
    modelCode: 'MB-GRD-DISHWASHER',
    genericModelNumber: '103158',
  },
  grundig_EA: {
    modelCode: 'MB-GRD-CONDENSING TUMBLE DRYER',
    genericModelNumber: '103159',
  },
  grundig_FF: {
    modelCode: 'MB-GRD-FRIDGE FREEZER',
    genericModelNumber: '103160',
  },
  grundig_FR: {
    modelCode: 'MB-GRD-FRIDGE',
    genericModelNumber: '103161',
  },
  grundig_FS: {
    modelCode: 'MB-GRD-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '103162',
  },
  grundig_FT: {
    modelCode: 'MB-GRD-FROST FREE FREEZER',
    genericModelNumber: '103163',
  },
  grundig_FZ: {
    modelCode: 'MB-GRD-FREEZER',
    genericModelNumber: '103164',
  },
  'ikea (multibranding)_OC': {
    modelCode: 'MB-ZIK-GAS OVEN',
    genericModelNumber: '103286',
  },
  swan_OC: {
    modelCode: 'MB-SWA-GAS OVEN',
    genericModelNumber: '103334',
  },
  grundig_EH: {
    modelCode: 'MB-GRD-ELECTRIC HOB',
    genericModelNumber: '103371',
  },
  grundig_MW: {
    modelCode: 'MB-GRD-MICROWAVE',
    genericModelNumber: '103372',
  },
  grundig_EO: {
    modelCode: 'MB-GRD-ELECTRIC OVEN',
    genericModelNumber: '103373',
  },
  grundig_RQ: {
    modelCode: 'MB-GRD-RANGE COOKER',
    genericModelNumber: '103374',
  },
  grundig_SD: {
    modelCode: 'MB-GRD-SPIN DRYER',
    genericModelNumber: '103375',
  },
  grundig_TD: {
    modelCode: 'MB-GRD-TUMBLE DRYER',
    genericModelNumber: '103376',
  },
  grundig_WD: {
    modelCode: 'MB-GRD-WASHER DRYER',
    genericModelNumber: '103377',
  },
  kitchenaid_MX: {
    modelCode: 'KITCHENAID MIXER',
    genericModelNumber: '104023',
  },
  kitchenaid_OV: {
    modelCode: 'OVEN KITCHENAID BI',
    genericModelNumber: '104163',
  },
  leisure_DC: {
    modelCode: 'MB-LEI-DUAL FUEL COOKER',
    genericModelNumber: '104300',
  },
  leisure_ME: {
    modelCode: 'MB-LEI-COFFEE MAKER',
    genericModelNumber: '104301',
  },
  leisure_TT: {
    modelCode: 'MB-LEI-TWIN TUB',
    genericModelNumber: '104302',
  },
  leisure_AW: {
    modelCode: 'MB-LEI-WASHING MACHINE',
    genericModelNumber: '104303',
  },
  leisure_EA: {
    modelCode: 'MB-LEI-CONDENSING TUMBLE DRYER',
    genericModelNumber: '104304',
  },
  leisure_FR: {
    modelCode: 'MB-LEI-FRIDGE',
    genericModelNumber: '104305',
  },
  leisure_WD: {
    modelCode: 'MB-LEI-WASHER DRYER',
    genericModelNumber: '104306',
  },
  leisure_OC: {
    modelCode: 'MB-LEI-GAS OVEN',
    genericModelNumber: '104307',
  },
  leisure_FT: {
    modelCode: 'MB-LEI-FROST FREE FREEZER',
    genericModelNumber: '104362',
  },
  leisure_MW: {
    modelCode: 'MB-LEI-MICROWAVE',
    genericModelNumber: '104363',
  },
  leisure_SD: {
    modelCode: 'MB-LEI-SPIN DRYER',
    genericModelNumber: '104364',
  },
  leisure_TD: {
    modelCode: 'MB-LEI-TUMBLE DRYER',
    genericModelNumber: '104365',
  },
  beko_GH: {
    modelCode: 'MB-BEK-GAS HOB',
    genericModelNumber: '144212',
  },
  proline_GH: {
    modelCode: 'MB-PRL-GAS HOB',
    genericModelNumber: '144226',
  },
  grundig_GH: {
    modelCode: 'MB-GRD-GAS HOB',
    genericModelNumber: '144285',
  },
  blomberg_GH: {
    modelCode: 'MB-BLM-GAS HOB',
    genericModelNumber: '144313',
  },
  'ikea (multibranding)_GH': {
    modelCode: 'MB-ZIK-GAS HOB',
    genericModelNumber: '144385',
  },
  swan_GH: {
    modelCode: 'MB-SWA-GAS HOB',
    genericModelNumber: '144429',
  },
  leisure_GH: {
    modelCode: 'MB-LEI-GAS HOB',
    genericModelNumber: '144464',
  },
  flavel_EH: {
    modelCode: 'MB-FLA-ELECTRIC HOB',
    genericModelNumber: '148883',
  },
  flavel_EO: {
    modelCode: 'MB-FLA-ELECTRIC OVEN',
    genericModelNumber: '148884',
  },
  flavel_DW: {
    modelCode: 'MB-FLA-DISHWASHER',
    genericModelNumber: '148885',
  },
  flavel_FR: {
    modelCode: 'MB-FLA-FRIDGE',
    genericModelNumber: '148886',
  },
  flavel_AW: {
    modelCode: 'MB-FLA-WASHING MACHINE',
    genericModelNumber: '148887',
  },
  flavel_CH: {
    modelCode: 'MB-FLA-COOKER HOOD',
    genericModelNumber: '148888',
  },
  ikea_CN: {
    modelCode: 'MB-IKA-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '149157',
  },
  ikea_SD: {
    modelCode: 'MB-IKA-SPIN DRYER',
    genericModelNumber: '149169',
  },
  ikea_FT: {
    modelCode: 'MB-IKA-FROST FREE FREEZER',
    genericModelNumber: '149164',
  },
  ikea_WD: {
    modelCode: 'MB-IKA-WASHER DRYER',
    genericModelNumber: '149171',
  },
  ikea_FZ: {
    modelCode: 'MB-IKA-FREEZER',
    genericModelNumber: '149165',
  },
  ikea_RQ: {
    modelCode: 'MB-IKA-RANGE COOKER',
    genericModelNumber: '149168',
  },
  ikea_TT: {
    modelCode: 'MB-IKA-TWIN TUB',
    genericModelNumber: '148895',
  },
  ikea_DC: {
    modelCode: 'MB-IKA-DUAL FUEL COOKER',
    genericModelNumber: '149152',
  },
  ikea_MW: {
    modelCode: 'MB-IKA-MICROWAVE',
    genericModelNumber: '148897',
  },
  ikea_ME: {
    modelCode: 'MB-IKA-COFFEE MAKER',
    genericModelNumber: '149153',
  },
  ikea_FR: {
    modelCode: 'MB-IKA-FRIDGE',
    genericModelNumber: '149162',
  },
  ikea_DW: {
    modelCode: 'MB-IKA-DISHWASHER',
    genericModelNumber: '149160',
  },
  flavel_FF: {
    modelCode: 'MB-FLA-FRIDGE FREEZER',
    genericModelNumber: '148902',
  },
  flavel_DO: {
    modelCode: 'MB-FLA-DOUBLE OVEN',
    genericModelNumber: '148903',
  },
  flavel_RQ: {
    modelCode: 'MB-FLA-RANGE COOKER',
    genericModelNumber: '148904',
  },
  flavel_CK: {
    modelCode: 'MB-FLA-GAS COOKER',
    genericModelNumber: '148905',
  },
  flavel_EC: {
    modelCode: 'MB-FLA-ELECTRIC COOKER',
    genericModelNumber: '148906',
  },
  flavel_FZ: {
    modelCode: 'MB-FLA-FREEZER',
    genericModelNumber: '148907',
  },
  flavel_FS: {
    modelCode: 'MB-FLA-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '148908',
  },
  ikea_AW: {
    modelCode: 'MB-IKA-WASHING MACHINE',
    genericModelNumber: '149154',
  },
  ikea_CH: {
    modelCode: 'MB-IKA-COOKER HOOD',
    genericModelNumber: '149155',
  },
  ikea_HB: {
    modelCode: 'HOB IKEA BI',
    genericModelNumber: '148911',
  },
  ikea_CK: {
    modelCode: 'MB-IKA-GAS COOKER',
    genericModelNumber: '149156',
  },
  ikea_TD: {
    modelCode: 'MB-IKA-TUMBLE DRYER',
    genericModelNumber: '149170',
  },
  ikea_FF: {
    modelCode: 'MB-IKA-FRIDGE FREEZER',
    genericModelNumber: '148915',
  },
  ikea_EC: {
    modelCode: 'MB-IKA-ELECTRIC COOKER',
    genericModelNumber: '149158',
  },
  ikea_DO: {
    modelCode: 'MB-IKA-DOUBLE OVEN',
    genericModelNumber: '149159',
  },
  ikea_EA: {
    modelCode: 'MB-IKA-CONDENSING TUMBLE DRYER',
    genericModelNumber: '149161',
  },
  ikea_FS: {
    modelCode: 'MB-IKA-FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '149163',
  },
  ikea_EH: {
    modelCode: 'MB-IKA-ELECTRIC HOB',
    genericModelNumber: '149166',
  },
  ikea_EO: {
    modelCode: 'MB-IKA-ELECTRIC OVEN',
    genericModelNumber: '149167',
  },
  flavel_DC: {
    modelCode: 'MB-FLA-DUAL FUEL COOKER',
    genericModelNumber: '149248',
  },
  flavel_FT: {
    modelCode: 'MB-FLA-FROST FREE FREEZER',
    genericModelNumber: '149249',
  },
  flavel_MW: {
    modelCode: 'MB-FLA-MICROWAVE',
    genericModelNumber: '149250',
  },
  flavel_SD: {
    modelCode: 'MB-FLA-SPIN DRYER',
    genericModelNumber: '149251',
  },
  flavel_ME: {
    modelCode: 'MB-FLA-COFFEE MAKER',
    genericModelNumber: '149253',
  },
  flavel_TT: {
    modelCode: 'MB-FLA-TWIN TUB',
    genericModelNumber: '149254',
  },
  flavel_CN: {
    modelCode: 'MB-FLA-AMERICAN STYLE F/FREEZER',
    genericModelNumber: '149255',
  },
  flavel_EA: {
    modelCode: 'MB-FLA-CONDENSING TUMBLE DRYER',
    genericModelNumber: '149256',
  },
  flavel_TD: {
    modelCode: 'MB-FLA-TUMBLE DRYER',
    genericModelNumber: '149257',
  },
  flavel_OC: {
    modelCode: 'MB-FLA-GAS OVEN',
    genericModelNumber: '149258',
  },
  flavel_WD: {
    modelCode: 'MB-FLA-WASHER DRYER',
    genericModelNumber: '149259',
  },
  flavel_GH: {
    modelCode: 'MB-FLA-GAS HOB',
    genericModelNumber: '149260',
  },
  zenith_CH: {
    modelCode: 'ZENITH HOB ELECTRIC',
    genericModelNumber: '153159',
  },
  ikea_GH: {
    modelCode: 'MB-IKA-GAS HOB',
    genericModelNumber: '149420',
  },
  ikea_OC: {
    modelCode: 'MB-IKA-GAS OVEN',
    genericModelNumber: '149421',
  },
  zenith_EH: {
    modelCode: 'ZENITH ELECTRIC HOB',
    genericModelNumber: '150424',
  },
  zenith_EO: {
    modelCode: 'ZENITH ELECTRIC OVEN',
    genericModelNumber: '150425',
  },
  zenith_FT: {
    modelCode: 'ZENITH FROST FREE FREEZER',
    genericModelNumber: '150426',
  },
  zenith_CK: {
    modelCode: 'ZENITH GAS COOKER',
    genericModelNumber: '150427',
  },
  zenith_EA: {
    modelCode: 'ZENITH CONDENSING TUMBLE DRYER',
    genericModelNumber: '150428',
  },
  zenith_CN: {
    modelCode: 'ZENITH AMERICAN STYLE F/FREEZER',
    genericModelNumber: '150429',
  },
  zenith_GH: {
    modelCode: 'ZENITH GAS HOB',
    genericModelNumber: '150430',
  },
  zenith_RQ: {
    modelCode: 'ZENITH RANGE COOKER',
    genericModelNumber: '150431',
  },
  zenith_FS: {
    modelCode: 'ZENITH FROST FREE FRIDGE/FREEZER',
    genericModelNumber: '150432',
  },
  zenith_EC: {
    modelCode: 'ZENITH ELECTRIC COOKER',
    genericModelNumber: '150433',
  },
  zenith_DC: {
    modelCode: 'ZENITH DUAL FUEL COOKER',
    genericModelNumber: '150434',
  },
  zenith_ME: {
    modelCode: 'ZENITH COFFEE MAKER',
    genericModelNumber: '150435',
  },
  zenith_TT: {
    modelCode: 'ZENITH TWIN TUB',
    genericModelNumber: '150436',
  },
  zenith_SD: {
    modelCode: 'ZENITH SPIN DRYER',
    genericModelNumber: '150437',
  },
  zenith_DO: {
    modelCode: 'ZENITH DOUBLE OVEN',
    genericModelNumber: '153261',
  },
};
